<script>
import ContentTitle from '@/components/new-match-detail/ContentTitle.vue'
import { QNImageUtil, buildWebviewShareFullUrl, notifyMiniProgramShare } from '@/utils'

export default {
  components: {
    ContentTitle
  },
  data() {
    return {
      sportType: null,
      componentList: null,
      componentData: null,
      beginDate: null,
      endDate: null
    }
  },
  watch: {
    componentList(list) {
      if (list && list.length) {
        this.$nextTick(() => this.setupAppShare())
      }
    },
    '$parent.matchTopInfo': {
      deep: true,
      handler(info) {
        if (info && info.name && this.componentList && this.componentList.length) {
          this.setupAppShare()
        }
      }
    }
  },
  methods: {
    getPromotion(beginDate, endDate) {
      if (!beginDate || !endDate) return ''
      const startTime = new Date(beginDate)
      const endTime = new Date(endDate)
      const currentTime = new Date()
      if (currentTime < startTime) return '-敬请期待'
      if (currentTime >= startTime && currentTime <= endTime) return '-激战正酣'
      return '-完美闭幕'
    },
    setupAppShare() {
      const top = this.$parent && this.$parent.matchTopInfo
      if (!top || !top.name) return
      const nameStr = String(top.name)
      const nameParts = nameStr.split('_')
      const logo = top.logoUrl
      const shareObj = {
        title: (nameParts[0] || nameStr) + this.getPromotion(this.beginDate, this.endDate),
        abstract: nameParts[1] || nameStr,
        image: logo
          ? (logo.indexOf('http') === 0 ? logo : QNImageUtil.imageView(logo))
          : '',
        link: buildWebviewShareFullUrl(this.$route)
      }
      if (typeof this.wxShare === 'function') {
        this.wxShare(shareObj)
      }
      notifyMiniProgramShare(shareObj, this.$route)
    }
  }
}
</script>

<template>
  <div class="home-container">
    <div v-for="(item, index) in componentList" :key="index" class="content-box">
      <ContentTitle :information="item" :items="componentData && componentData[item.component]" />
    </div>
  </div>
</template>
<style scoped lang="scss">
.content-box{
  margin-top: 12px;
}
</style>